<!--
@Author: MIYONGLE
@Desc: 产品服务-灵活用功系统pc
@Date: 2021-07-28 13时
-->
<template>
  <div class="page-main">
    <!-- 顶部 -->
    <mMenusNav><span>{{ titleName }}</span></mMenusNav>
    
    <!-- 主体部分 -->
    <div class="body">
      <div class="title">慧用工灵活用工系统</div>
      <div class="body-txt">
        <p>企业级免费灵活用工SaaS系统</p>
        <p>帮助企业实现任务发布、在线签约、智能审核、薪酬结算，灵工管理等职能服务</p>
      </div>
    </div>

    <!-- 产品优势 -->
    <div class="advantage">
      <div class="advantage-title">产品优势</div>
      <ul>
        <li  v-for="item in advantageArray" :key="item.subtitleName">
          <div class="Subtitle">{{item.subtitleName}}</div>
          
          <div class="advantage-centent" v-if="item.subtitleName=='任务发布'" :style="heigth='180px'"><p>{{item.centent}}</p></div>
          <div class="advantage-centent2" v-else-if="item.subtitleName=='智能审核'" :style="heigth='72px'"><p>{{item.centent}}</p></div>
          <div class="advantage-centent3" v-else-if="item.subtitleName=='薪酬结算'" :style="heigth='216px'">
            <p>
              <span>高效导入：企业可批量上传任务服务费结算单。</span><br>
              <span>秒级到账：实时对接银行系统，支持7*24小时结算下发，可下发至自由职业者个人银行账户、微信钱包账户、支付宝账户。</span><br>
              <!-- <span></span><br> -->
              <span>专管账户：招商、网商银行专管账户，只能按企业命令进行下发，资金无挪用风险。</span>
            </p>
          </div>
          <div class="advantage-centent4" v-else :style="heigth='72px'"><p>{{item.centent}}</p></div>

          <div class="advantage-img">
            <img :src="item.src" alt="">
          </div>       
        </li>
      </ul>
    </div>
    <!-- form弹窗 -->
    <mFrom :source='source'></mFrom>
  </div>
</template>

<script type="text/javascript">
import mMenusNav from "../../components/mMenusNav";
import {ADVANTAGE} from "../../service/businessConsts";
import mFrom from "../../components/mFrom";
export default {
  name: "app",
  data() {
    return {
      source:'',
      titleName: "灵活用工系统",
      advantageArray:ADVANTAGE
    }
  },
  components: {
    mMenusNav: mMenusNav,
    mFrom: mFrom,
  },
  created() {
    // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=mcpfw_lhyg' : '&pageFrom=mcpfw_lhyg';
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.body{
  width: 100%;
  height: 1080px;
  overflow: hidden;
  background-image: url(../../../static/mobile/mprodServPc/banner_product_1.png);
  background-repeat:no-repeat;
  background-size: 100%;
  background-color: #1b6ef1;
  .title{
    margin:0 auto;
    margin-top: 181px;
    // width: 622px;
    height: 66px;
    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 66px;
  }
  .body-txt{
    margin: 0 auto;
    margin-top: 28px;
    // width: 575px;
    padding: 0px 87.5px;
    height: 120px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
  }
}
.advantage{
  margin:0 auto;
  width: 100%;
  // width: 750px;
  overflow: hidden;
  background: #FBFDFF;
  .advantage-title{
    margin:0 auto;
    margin-top: 70px;
    // width: 160px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100F0F;
    line-height: 56px;
  }
  .Subtitle{
    margin:0 auto;
    margin-top: 55px;
    // width: 112px;
    // height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #403F3F;
    line-height: 40px;
  }
  .advantage-centent{
    margin:0 auto;
    margin-top: 12px;
    // padding: 0px 80px;
    padding: 0px 100px;
    // width: 590px;
    // height:108px;
    text-align: left;
    -webkit-text-size-adjust: none;
    p{
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #403F3F;
      line-height: 36px;
    }
  }
  .advantage-centent2{
    margin:0 auto;
    margin-top: 12px;
    // padding: 0px 80px;
    padding: 0px 100px;
    // width: 590px;
    // height:72px;
    text-align: left;
    -webkit-text-size-adjust: none;
    p{
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #403F3F;
      line-height: 36px;
    }
  }
  .advantage-centent3{
    margin:0 auto;
    margin-top: 12px;
    // padding: 0px 80px;
    padding: 0px 100px;
    // width: 495px;
    // height:216px;
    text-align: left;
    -webkit-text-size-adjust: none;
    p{
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #403F3F;
      line-height: 36px;
    }
  }
  .advantage-centent4{
    margin:0 auto;
    margin-top: 12px;
    padding: 0px 100px;
    // width: 495px;
    // height:72px;
    text-align: left;
    -webkit-text-size-adjust: none;
    p{
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #403F3F;
      line-height: 36px;
    }
  }
  .advantage-img{
    margin:0 auto;
    margin-top: 16px;
    margin-bottom: 115px;
    // width: 480px;
    height: 320px;
    img{
      // width: 480px;
      height: 320px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mProdServ_pc.vue